<div class="bg-white">
    <div class="ff-spectral fs-6 fw-bold text-primary text-center d-md-none pt-3 mb-0">
        Specification
    </div>
    <div class="px-4 pt-4 pb-5 p-xl-4">
        <div class="row row--max g-4 g-md-2 g-lg-3">
            <div class="col-4 col-md-2 d-flex flex-column align-items-center">
                <img class="product__attribute_img mb-2 mb-md-3" src="../../../../../assets/images/icon-product-texture.png"/>
                <p class="text-primary fs-small text-center mb-0">
                    <span class="fw-bold mb-2">Texture</span>
                    <br/>
                    <span *ngIf="product.finish === 71">Natural</span>
                    <span *ngIf="product.finish === 72">Smooth</span>
                </p>
            </div>
            <div class="col-4 col-md-2 d-flex flex-column align-items-center">
                <img class="product__attribute_img mb-2 mb-md-3" src="../../../../../assets/images/vicon-product-thickness.png"/>
                <p class="text-primary fs-small text-center mb-0">
                    <span class="fw-bold mb-2">Thickness</span>
                    <br/>
                    <span *ngIf="product.sellUnit.id === 'ST'">Random</span>
                    <span *ngIf="product.sellUnit.id !== 'ST'">
                        {{minThickness}}<span *ngIf="maxThickness > 0">mm - {{maxThickness}}mm</span>
                    </span>
                </p>
            </div>
            <div class="col-4 col-md-2 d-flex flex-column align-items-center">
                <img class="product__attribute_img mb-2 mb-md-3" src="../../../../../assets/images/icon-product-tolerance.png"/>
                <p class="text-primary fs-small text-center mb-0">
                    <span class="fw-bold mb-2">Tolerance</span>
                    <br>{{product.tolerance}}</p>
            </div>
            <div class="col-4 col-md-2 d-flex flex-column align-items-center">
                <img class="product__attribute_img mb-2 mb-md-3" src="../../../../../assets/images/icon-product-lead-time.png"/>
                <p class="text-primary fs-small text-center mb-0">
                    <span class="fw-bold mb-2">Average</span>
                    <br/>{{product.leadTime}}<br/>Lead Time</p>
            </div>
            <div class="col-4 col-md-2 d-flex flex-column align-items-center">
                <img class="product__attribute_img mb-2 mb-md-3" src="../../../../../assets/images/icon-product-recommended-joint.png"/>
                <p class="text-primary fs-small text-center mb-0">
                    <span class="fw-bold mb-2">Recommended</span>
                    <br/>{{product.recommendedJoint}}<br/>Joint</p>
            </div>
            <div class="col-4 col-md-2 d-flex flex-column align-items-center">
                <img class="product__attribute_img mb-2 mb-md-3" src="../../../../../assets/images/icon-product-quarry-location.png"/>
                <p class="text-primary fs-small text-center mb-0">
                    <span class="fw-bold mb-2">Quarry Location</span>
                    <br/>{{product.location}}</p>
            </div>
        </div>
    </div>
</div>
